/**
 * User: WangMeng
 * Date: 2018-07-17
 * Time: 17:45
 * Desc: 大额政府补助
 */

import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class GovernmentAllowance extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.title = '政府补助情况';
    }

    getColumns = () => {
        return [{
            title: '当期利润总额',
            dataIndex: 'netProfit'
        }, {
            title: '政府补助',
            dataIndex: 'govSubsidy'
        }, {
            title: '政府补助占利润总额比例',
            dataIndex: 'govSubsidyRate'
        }];
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/danger/GovernmentAllowance.jsx